export default "__VITE_ASSET__Blexukt$__"